<form class="createForm" [formGroup]="formGroup">
  <mat-form-field appearance="outline">
    <mat-label>Наименование</mat-label>
    <input formControlName="description" matInput placeholder="Наименование" />
  </mat-form-field>
  <mat-checkbox formControlName="oe">Оригинал</mat-checkbox>
  <button mat-button (click)="create()">Сохранить</button>
</form>
